import React from "react";
import {
    FaInstagram,
    FaLinkedin,
    FaWhatsapp,
    FaYoutube,
    FaPinterest,
} from "react-icons/fa";
import { SiX, SiTiktok } from "react-icons/si";

const SocialBar = () => {
    return (
        <div
            className="fixed top-1/2 right-4 md:right-6 lg:right-8 transform -translate-y-1/2 
      bg-black bg-opacity-60 p-4 md:p-5 lg:p-6 rounded-2xl shadow-2xl flex flex-col 
      gap-3 md:gap-4 lg:gap-5 items-center backdrop-blur-md z-50"
        >
            <a
                href="https://www.instagram.com/_slowork/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#E0BB44] hover:text-white transition-all duration-300"
            >
                <FaInstagram size={22} className="md:size-22 lg:size-25" />
            </a>

            <a
                href="https://www.linkedin.com/company/slow-working/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#E0BB44] hover:text-white transition-all duration-300"
            >
                <FaLinkedin size={20} className="md:size-22 lg:size-25" />
            </a>

            <a
                href="https://whatsapp.com/channel/0029VayVun62975FMxHhjS0J"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#E0BB44] hover:text-white transition-all duration-300"
            >
                <FaWhatsapp size={20} className="md:size-22 lg:size-25" />
            </a>

            <a
                href="https://www.tiktok.com/@_slowork?lang=es"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#E0BB44] hover:text-white transition-all duration-300"
            >
                <SiTiktok size={20} className="md:size-22 lg:size-25" />
            </a>

            <a
                href="https://www.youtube.com/@Sloworking"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#E0BB44] hover:text-white transition-all duration-300"
            >
                <FaYoutube size={20} className="md:size-22 lg:size-25" />
            </a>

            <a
                href="https://x.com/_Slowork"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#E0BB44] hover:text-white transition-all duration-300"
            >
                <SiX size={20} className="md:size-22 lg:size-25" />
            </a>

            <a
                href="https://es.pinterest.com/sloworkadmin"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#E0BB44] hover:text-white transition-all duration-300"
            >
                <FaPinterest size={20} className="md:size-22 lg:size-25" />
            </a>
        </div>
    );
};

export default SocialBar;
